import { AuthenticationService } from "../../services/authentication.service";
import { TranslateService } from '@ngx-translate/core';
var NavbarComponent = (function () {
    function NavbarComponent(authService, translate) {
        this.authService = authService;
        this.translate = translate;
        this.language = '';
        this.username = '';
        this.language = translate.currentLang;
    }
    NavbarComponent.prototype.ngOnInit = function () {
        var username = localStorage.getItem('username');
        this.username = username;
    };
    NavbarComponent.prototype.stopPropagation = function (event) {
        event.stopPropagation();
    };
    NavbarComponent.prototype.canUserSignDoc = function () {
        return this.authService.isAccountant();
    };
    NavbarComponent.prototype.changeLanguage = function (lang) {
        if (lang === 'en') {
            this.translate.use('en');
            localStorage.setItem('lang', 'en');
        }
        else if (lang === 'th') {
            this.translate.use('th');
            localStorage.setItem('lang', 'th');
        }
    };
    NavbarComponent.prototype.isAdmin = function () {
        return this.authService.isAdmin();
    };
    NavbarComponent.prototype.isUIH = function () {
        return this.authService.isUIH();
    };
    NavbarComponent.prototype.isAccountant = function () {
        return this.authService.isAccountant();
    };
    NavbarComponent.prototype.isAccountantAdmin = function () {
        return this.authService.isAccountantAdmin();
    };
    NavbarComponent.prototype.isIT = function () {
        return this.authService.isIT();
    };
    NavbarComponent.prototype.getUsername = function () {
        return localStorage.getItem('username');
    };
    NavbarComponent.prototype.getRole = function () {
        return localStorage.getItem('group');
    };
    return NavbarComponent;
}());
export { NavbarComponent };



// WEBPACK FOOTER //
// /opt/app/src/app/core/navbar/navbar.component.ts.pre-build-optimizer.js